import Checkbox from "components/ui/atoms/Checkbox";
import { useController } from "react-hook-form";

const CustomBooleanField = ({ field, control }) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });

  return (
    <Checkbox
      {...fieldProps}
      nullable={field.allow_null}
      disabled={field.disabled}
      name={field.name}
      helperText={fieldState.error?.message || field.help_text || ""}
      error={!!fieldState.error}
      label={field.label}
      sx={{ display: field.hidden ? "none" : "block" }}
    />
  );
};

export default CustomBooleanField;
